import { connect } from 'react-redux';

import AdvancePaySetupPresentation from './AdvancePaySetupPresentation';

import { advancePayActions, recursiveBillingSetupActions } from 'dataflow/billingPortal/actions';

function mapStateToProps(state) {    
	return {
        ...state.recursiveBillingSetupReducers,
        ...state.advancePayReducers,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getAdvancePaySetupList: (pageNo, pageSize, sort, filterOptions) => { dispatch(advancePayActions.getAdvancePaySetupList(pageNo, pageSize, sort, filterOptions)); },
        getAllAdvancePaySetupList: (pageNo, pageSize, sort, filterOptions) => { dispatch(advancePayActions.getAllAdvancePaySetupList(pageNo, pageSize, sort, filterOptions)); },
        
        addAccount: (accountDetails) => { dispatch(advancePayActions.addAccount(accountDetails)); },
        updateAccount: (accountDetails) => { dispatch(advancePayActions.updateAccount(accountDetails)); },
        generateInvoice: (accountDetails) => { dispatch(advancePayActions.generateInvoice(accountDetails)); },
        generateDebitNote: (accountDetails) => { dispatch(advancePayActions.generateDebitNote(accountDetails)); },
        deleteAccount: (accountId) => { dispatch(advancePayActions.deleteAccount(accountId)); },

        getFullAgentCodeList: (remarkObj) => { dispatch(recursiveBillingSetupActions.getFullAgentCodeList(remarkObj)); },
        getFullProductDetailList: (remarkObj) => { dispatch(recursiveBillingSetupActions.getFullProductDetailList(remarkObj)); }
    };
}

const AdvancePaySetup = connect(mapStateToProps, mapDispatchToProps)(AdvancePaySetupPresentation);

export default AdvancePaySetup;